module.exports = __webpack_public_path__ + "static/media/Imagen_2.da67aafd.jpg";